import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Redirect, Route, Switch, withRouter } from 'react-router-dom'
import { Container } from 'reactstrap'
import { localGet, localRemove } from '../lib/session'
import PERMISSION from '../const/userPermission'
import { AppBreadcrumb, AppFooter, AppHeader } from '@coreui/react'
import routes from '../routes/routes'
import DefaultFooter from './defaultFooter'
import DefaultHeader from './defaultHeader'
import Sidebar from './sidebar/Sidebar'
import SidebarContext from './sidebar/SidebarContext'
import rules from './rules'
import LoadingComponent from '../components/loading'
import { FeeChangeNotice } from '../components/FeeChangeNotice'
import AlertStrapiBanner from '../components/alertStrapiBanner'
import { setStatusAuth } from '../actions/user'
import { clearBranch } from '../actions/branch'
import { logout as logoutService } from '../service/user'
import { LEGACY_NAV } from '../config/featureFlags'

// Tempo máximo que o overlay de boot pode segurar a UI (falha de rede no
// /store/branches ou /available não pode travar o portal)
const BOOT_GATE_TIMEOUT_MS = 8000

class DefaultLayout extends Component {
  constructor(props) {
    super(props)
    this.state = {
      mobileOpen: false,
      // boot gate: overlay de tela cheia até o menu e a landing estabilizarem,
      // escondendo os saltos visuais do carregamento inicial
      revealed: false,
      forceReady: false,
      salesLoadStarted: false,
      salesLoadDone: false
    }
    this.setMobileOpen = this.setMobileOpen.bind(this)
    this.handleLogout = this.handleLogout.bind(this)
  }

  componentDidMount() {
    this.bootTimeout = setTimeout(() => {
      this.setState({ forceReady: true })
    }, BOOT_GATE_TIMEOUT_MS)
  }

  componentWillUnmount() {
    clearTimeout(this.bootTimeout)
  }

  componentDidUpdate() {
    const { listByDateTransaction } = this.props
    const { revealed, salesLoadStarted, salesLoadDone } = this.state

    if (revealed) return

    // primeiro ciclo da lista de Vendas Hoje: o fetch só dispara depois do
    // listBranch chegar, então observamos isLoading subir e depois descer
    if (!salesLoadStarted && listByDateTransaction?.isLoading === true) {
      this.setState({ salesLoadStarted: true })
      return
    }
    if (salesLoadStarted && !salesLoadDone && listByDateTransaction?.isLoading === false) {
      this.setState({ salesLoadDone: true })
      return
    }

    if (this.isBootReady()) {
      this.setState({ revealed: true })
    }
  }

  isBootReady() {
    const { authUser, listBranch, ipirangaResolved, location } = this.props
    const { revealed, forceReady, salesLoadDone } = this.state

    if (revealed || forceReady) return true

    // fluxos sem o boot padrão (backoffice/busca-parceiro, rotas sem header)
    if (authUser?.readOnly) return true
    if (rules[location.pathname]?.hideHeader) return true

    const branchesReady = Array.isArray(listBranch?.data)
    if (!branchesReady || !ipirangaResolved) return false

    // na landing padrão, segura até a primeira carga da tabela terminar
    if (location.pathname === '/vendas-hoje' && !salesLoadDone) return false

    return true
  }

  setMobileOpen(value) {
    this.setState((prev) => ({
      mobileOpen: typeof value === 'function' ? value(prev.mobileOpen) : value
    }))
  }

  handleLogout() {
    const divChat = document.getElementById('blip-chat-container')
    if (divChat) divChat.remove()
    localRemove('CAMPAIN')
    this.props.clearBranch()
    logoutService()
    this.props.setStatusAuth()
    localStorage.removeItem('blipSdkUAccount')
    localStorage.removeItem('AUTH_TOKEN')
  }

  render() {
    const { authUser, location } = this.props
    const { readOnly } = authUser
    const { mobileOpen } = this.state

    let redirect = { from: '/', to: '/busca-parceiro' }
    const authLocal = localGet('AUTH_TOKEN')

    if (!!authLocal && !authLocal.Authorized && authLocal.Type === PERMISSION.portal) {
      redirect = { from: '/', to: '/em-breve' }
      return <Redirect to={{ pathname: '/em-breve' }} />
    }

    if (!readOnly) {
      redirect = { from: '/', to: '/vendas-hoje' }
    }

    const hideSidebar = rules[location.pathname]?.hideSidebar
    const appClassName = ['app', hideSidebar || LEGACY_NAV ? 'app--no-sidebar' : ''].filter(Boolean).join(' ')

    return (
      <SidebarContext.Provider
        value={{
          mobileOpen,
          setMobileOpen: this.setMobileOpen,
          logout: this.handleLogout
        }}
      >
        <div className={appClassName}>
          {!this.isBootReady() && <LoadingComponent fixed />}
          <FeeChangeNotice />
          {!LEGACY_NAV && !hideSidebar && <Sidebar />}
          <AppHeader fixed>
            <DefaultHeader />
          </AppHeader>
          <div className="app-body">
            <main className="main">
              {location.pathname !== '/busca-parceiro' && (
                <Container>
                  <AlertStrapiBanner />
                </Container>
              )}
              <AppBreadcrumb
                className="app-breadcrumb container px-0 border-bottom-0"
                appRoutes={routes}
              />
              <Container>
                <Switch>
                  {routes.map((route) =>
                    route.component ? (
                      <Route
                        key={route.name}
                        path={route.path}
                        exact={route.exact}
                        name={route.name}
                        render={(props) => <route.component {...props} />}
                      />
                    ) : null
                  )}
                  <Redirect {...redirect} />
                </Switch>
              </Container>
            </main>
          </div>
          <AppFooter className="mt-5 bg-primary">
            <DefaultFooter />
          </AppFooter>
        </div>
      </SidebarContext.Provider>
    )
  }
}

const mapStateToProps = ({ userState, branchState, ipirangaPromotionState, transactionState }) => ({
  authUser: userState.authUser,
  listBranch: branchState.listBranch,
  ipirangaResolved: ipirangaPromotionState.resolved,
  listByDateTransaction: transactionState.listByDateTransaction
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ setStatusAuth, clearBranch }, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DefaultLayout))
